import styled from 'styled-components'

export const ItemsContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

export const MoreItemsContainer = styled.div`
    display: flex;
`